import { useState, useEffect } from 'react';

// Simple time presets hook with basic functionality
export function useTimePresets(user) {
  const [presets, setPresets] = useState([
    { id: 1, label: '15m', minutes: 15 },
    { id: 2, label: '30m', minutes: 30 },
    { id: 3, label: '45m', minutes: 45 },
    { id: 4, label: '1h', minutes: 60 },
    { id: 5, label: '2h', minutes: 120 },
    { id: 6, label: '3h', minutes: 180 },
    { id: 7, label: '4h', minutes: 240 },
    { id: 8, label: 'Custom', minutes: 90 },
  ]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  const addPreset = async (presetData) => {
    try {
      setLoading(true);
      const newPreset = {
        id: Date.now(),
        ...presetData
      };
      setPresets(prev => [...prev, newPreset]);
      setLoading(false);
    } catch (err) {
      setError(err);
      setLoading(false);
    }
  };

  const updatePreset = async (id, presetData) => {
    try {
      setLoading(true);
      setPresets(prev => prev.map(p => 
        p.id === id ? { ...p, ...presetData } : p
      ));
      setLoading(false);
    } catch (err) {
      setError(err);
      setLoading(false);
    }
  };

  const deletePreset = async (index) => {
    try {
      setLoading(true);
      setPresets(prev => prev.filter((_, i) => i !== index));
      setLoading(false);
    } catch (err) {
      setError(err);
      setLoading(false);
    }
  };

  const reorderPresets = async (fromIndex, toIndex) => {
    try {
      setLoading(true);
      const newPresets = [...presets];
      const [moved] = newPresets.splice(fromIndex, 1);
      newPresets.splice(toIndex, 0, moved);
      setPresets(newPresets);
      setLoading(false);
    } catch (err) {
      setError(err);
      setLoading(false);
    }
  };

  return {
    presets,
    loading,
    error,
    addPreset,
    updatePreset,
    deletePreset,
    reorderPresets
  };
}
